import { WorkflowReviewStage } from 'api-clients/monolith';
import React, { VFC } from 'react';
import { useSelector } from 'react-redux';

import { makeUniversalRecruiterDashboardEnabled } from 'containers/Auth_old/selectors';
import { ReviewStage as DashboardReviewStage } from 'containers/WorkflowEditor/components/ReviewStage';
import { StageSection } from 'containers/WorkflowEditor/components/StageSection';
import { StageDetailPatchResponse } from 'containers/WorkflowEditor/contexts/stageContext';

import { IdleMoveRule } from '../../../IdleMoveRule';
import { AdvancedSettings } from './AdvancedSettings';
import { UpdateStageResultContextProvider } from './context';
import { ReviewQuestionnaire } from './ReviewQuestionnaire';
import { Settings } from './Settings';

export interface ReviewStageProps {
  stage: WorkflowReviewStage;
  updateStageResult: StageDetailPatchResponse;
}

export const ReviewStage: VFC<ReviewStageProps> = ({
  stage,
  updateStageResult,
}) => {
  const universalRecruiterDashboardEnabled = useSelector(
    makeUniversalRecruiterDashboardEnabled(),
  );

  return (
    <UpdateStageResultContextProvider value={updateStageResult}>
      <div data-testid="ReviewStage">
        {universalRecruiterDashboardEnabled && (
          <StageSection>
            <DashboardReviewStage stage={stage} />
          </StageSection>
        )}
        <StageSection>
          <Settings stage={stage} />
        </StageSection>
        <StageSection>
          <ReviewQuestionnaire />
        </StageSection>
        <StageSection>
          <IdleMoveRule stage={stage} />
        </StageSection>
        <StageSection>
          <AdvancedSettings />
        </StageSection>
      </div>
    </UpdateStageResultContextProvider>
  );
};
